import React, { useState } from "react";

import NavItem from "./NavItem";
import { useSelector } from "react-redux";
import { isEmployee } from "../../../utils/auth";

export const adminMenu = [
  {
    name: "Dashboard",
    path: "dashboard",
    icon: ["fas", "gauge-high"],
    position: 1,
    items: [],
  },
  {
    name: "Administratori",
    path: "administrator",
    icon: ["fas", "users"],
    position: 2,
    items: [
      {
        name: "Kreiraj administratora",
        path: "administrator-add",
        position: 1,
      },
      { name: "Lista administratora", path: "administrator-list", position: 2 },
    ],
  },
  {
    name: "Proizvodi",
    path: "product",
    icon: ["fas", "shop"],
    position: 3,
    items: [
      { name: "Kreiraj proizvod", path: "product-add", position: 1 },
      { name: "Lista proizvoda", path: "product-list", position: 2 },
    ],
  },
  {
    name: "Pregled kupovina",
    path: "receipt-list",
    icon: ["fas", "cart-shopping"],
  },
  {
    name: "Kontakt forma",
    path: "contact-list",
    icon: ["fas", "fa-envelope"],
  },
];

const LeftSidebar = ({ menuActive, onClick }) => {
  const loggedUserReducer = useSelector((state) => state.loggedUserReducer);
  const [openMenu, setOpenMenu] = useState(null);
  const loggedUser = loggedUserReducer?.loggedUser;
  const menuItems = isEmployee(loggedUser)
    ? adminMenu.filter((item) => item.path === "receipt-list")
    : adminMenu;

  const handleToggleMenu = (menuKey) => {
    setOpenMenu((prevMenu) => (prevMenu === menuKey ? null : menuKey));
  };

  return (
    <div className={`sidebar-main-content ${menuActive && "active"}`}>
      <div className="navbar-brand-box">
        <div href="#0" className="logo logo-light">
          <span className="logo-lg">
            <img
              src="/images/fuka-logo-white.png"
              alt="Fuka"
              className="img-fluid"
            />
          </span>
        </div>
      </div>
      <ul className="navbar-nav" id="navbar-nav">
        {menuItems?.map((item, key) => (
          <NavItem
            item={item}
            key={key}
            onClick={onClick}
            openMenu={openMenu}
            handleToggleMenu={handleToggleMenu}
          />
        ))}
      </ul>
    </div>
  );
};

export default LeftSidebar;
